import { createFileRoute, Outlet } from '@tanstack/react-router';
import { operationsGuard } from '@/lib/route-guards';
import { OperationsSidebar } from '@/features/operations/components/operations-sidebar';

export const Route = createFileRoute('/operations')({
  beforeLoad: operationsGuard,
  component: OperationsRoute,
});

function OperationsRoute() {
  return (
    <div className="h-screen bg-background-light dark:bg-background-dark text-slate-900 dark:text-slate-100">
      <div className="flex h-screen flex-col lg:flex-row">
        <OperationsSidebar />
        <Outlet />
      </div>
    </div>
  );
}
